import { combineReducers } from 'redux'
// import settingsReducer from './settings'
import authReducer from './auth'
import violationReducer from './violations'
import capturesReducer from './select'
import userSettingsReducer from './settings/userGeneral'
import orgContactsReducer from './settings/orgContacts'
import orgSettingsReducer from './settings/orgGeneral'
import orgLicenseReducer from './settings/orgLicense'
import orgSettingsSettingsReducer from './settings/orgSettings'
import orgEmailReducer from './settings/orgEmail'
import aupsReducer from './settings/aups'
import userRolesReducer from './settings/userRoles'
import userPermissionsReducer from './settings/userListings'
import appExclusionsReducer from './settings/appExclusions'
import orgUnitsReducer from './settings/orgUnits'
import wordVaultReducer from './settings/words'
import whitelistReducer from './settings/whitelist'
import notificationsReducer from './notifications'
import alertsReducer from './settings/alerts'
import listingsReducer from './settings/listings'
import captureDataReducer from './captureData'
import groupsReducer from './settings/groups'
import reportsReducer from './settings/reports'
import usersReducer from './groups'
import filterReducer from './settings/filters'
import loadingReducer from './loading'
import integrationsReducer from './integrations'

export default combineReducers({
  // settings: settingsReducer,
  auth: authReducer,
  violations: violationReducer,
  selection: capturesReducer,
  userSettings: userSettingsReducer,
  orgContacts: orgContactsReducer,
  orgSettings: orgSettingsReducer,
  orgLicense: orgLicenseReducer,
  orgSettingsSettings: orgSettingsSettingsReducer,
  orgEmail: orgEmailReducer,
  aups: aupsReducer,
  userRoles: userRolesReducer,
  userListings: userPermissionsReducer,
  appExclusions: appExclusionsReducer,
  orgUnits: orgUnitsReducer,
  words: wordVaultReducer,
  whitelist: whitelistReducer,
  notifications: notificationsReducer,
  alerts: alertsReducer,
  listings: listingsReducer,
  captureData: captureDataReducer,
  supervisorGroups: groupsReducer,
  reports: reportsReducer,
  groups: usersReducer,
  filters: filterReducer,
  loadingState: loadingReducer,
  integrations: integrationsReducer
})
